module.exports = __webpack_public_path__ + "media/images/recruitment/landing/client01-f4f4ae0a78112be6d2eac153373b5c95.png";